import React, { useMemo, useState } from "react";
import {
  CommentReplyTypes,
  CommunityFeedCommment,
  CommunityFeedType,
} from "../../types";
import { CommentMenu, CommentContent, CommentReply } from "..";
import { useMutation, useQuery } from "@apollo/client";
import {
  CREATE_COMMENT_LIKE,
  DELETE_COMMENT_LIKE,
  DELETE_FEED_COMMENT,
  GET_COMMENT_REPLY,
  GET_FEEDS_COMMENTS,
  UPDATE_FEED_COMMENT,
} from "../../apollo/operations";
import { useSelector } from "react-redux";
import { BsArrowReturnRight } from "react-icons/bs";

type SingleComentProps = {
  commentFeed: CommunityFeedCommment | undefined;
  communityFeed: CommunityFeedType | undefined;
  refetch?: () => void;
  loadData?: boolean;
};

const SingleComent: React.FC<SingleComentProps> = ({
  commentFeed,
  communityFeed,
  refetch,
  loadData,
}) => {
  const [isEdited, setIsEdited] = React.useState(false);
  React.useEffect(() => {
    const editedFlag = localStorage.getItem("commentEditedFlag");

    if (editedFlag) {
      setIsEdited(false);
    } else {
      setIsEdited(Boolean(editedFlag));
    }
  }, []);
  const [editedComment, setEditedComment] = React.useState(
    commentFeed?.comments
  );
  const user = useSelector((state: any) => state.user.userDetails);
  const [openOption, setOpenOption] = React.useState(false);
  const [deleteOption, setDeleteOption] = React.useState(false);
  const [hideComment, setHideComment] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [replyComment, setReplyComment] = React.useState("");
  const [openInput, setOpenInput] = React.useState(false);
  const [deleteLikeLoading, setDeleteLikeLoading] = React.useState(false);
  const [createLikeLoading, setCreateLikeLoading] = React.useState(false);

  const { refetch: refetching } = useQuery(GET_FEEDS_COMMENTS, {
    variables: {
      where: {
        communityFeed: {
          id: communityFeed?.id,
        },
      },
    },
    onCompleted(data) {
      // console.log(data, "data comments");
    },
    onError: (err) => {
      console.log(err);
      const errorMessage = err.graphQLErrors[0]?.extensions?.originalError;
      console.log(errorMessage);
    },
  });

  const [commentLike] = useMutation(CREATE_COMMENT_LIKE, {
    onCompleted: (data) => {
      if (refetch) {
        refetch();
      }
      refetching();
    },
    onError: (err) => {
      console.log(err);
      const errorMessage = err.graphQLErrors[0]?.extensions?.originalError;
      console.log(errorMessage);
    },
  });

  // console.log(commentFeed?.commentLikes.length + " createLike");
  // console.log(likes + "create Like");

  const commentLikeCreator = commentFeed?.commentLikes.find(
    (like) => like.user.id === user.id
  )?.id;

  // console.log(commentLikeCreator, "commentLikeCreator");

  const [updateComment, { loading }] = useMutation(UPDATE_FEED_COMMENT, {
    onCompleted(data) {
      if (refetch) {
        refetch();
      }
    },
    onError: (err) => {
      console.log(err);
      const errorMessage = err.graphQLErrors[0]?.extensions?.originalError;
      console.log(errorMessage);
    },
  });

  const handleUpdateComment = async (e: any) => {
    e.preventDefault();
    await updateComment({
      variables: {
        data: {
          comments: editedComment!,
        },
        where: {
          id: commentFeed?.id,
        },
      },
    }).then(() => {
      localStorage.setItem("commentEditedFlag", "boolean");
      setIsEdited(true);
      setOpenEdit(false);
    });
  };

  const handleCommentLike = async (e: any) => {
    e.preventDefault();
    setCreateLikeLoading(true);
    await commentLike({
      variables: {
        data: {
          comment: {
            id: commentFeed?.id,
          },
          user: {
            id: user?.id,
          },
        },
      },
    }).then(() => {
      console.log(`liked by ${user.userDetails}`);
    });
  };

  const [deleteComment, { loading: loadFeeds }] = useMutation(
    DELETE_FEED_COMMENT,
    {
      onCompleted(data) {
        // console.log("data deleted", data);
        if (refetch) {
          refetch();
        }
      },
    }
  );

  const [deleteCommentLike] = useMutation(DELETE_COMMENT_LIKE, {
    onCompleted: () => {
      if (refetch) {
        refetch();
      }
    },
    onError: (err) => {
      console.log(err);
      const errorMessage = err.graphQLErrors[0]?.extensions?.originalError;
      console.log(errorMessage);
    },
  });

  const handleDeleteLike = async (e: any) => {
    e.preventDefault();
    setDeleteLikeLoading(true);
    if (user.id) {
      await deleteCommentLike({
        variables: {
          where: {
            id: commentLikeCreator,
          },
        },
      });
    }
  };
  //The delete function for the comment
  const handleDelete = async (e: any) => {
    e.preventDefault();
    if (
      commentFeed?.id &&
      (communityFeed?.creator.id || commentFeed.creator.id)
    ) {
      await deleteComment({
        variables: {
          where: {
            id: commentFeed?.id,
          },
        },
      }).then(() => {
        console.log("close delete");
        setDeleteOption(false);
      });
    }
  };

  useMemo(() => {
    if (!loadData) {
      setCreateLikeLoading(false);
      setDeleteLikeLoading(false);
    }
  }, [loadData]);

  const handleOpenNotice = () => {
    setOpenOption(false);
    setDeleteOption(!deleteOption);
  };

  const handleEdit = () => {
    setOpenOption(false);
    setOpenEdit(true);
  };

  const handleCloseEdit = () => {
    setOpenEdit(false);
  };

  const _image =
    commentFeed?.creator && commentFeed.creator?.ecobookProfile?.profileImage;
  // const commenters = commentFeed?.commentLikes && commentFeed.commentLikes.map((a) => {
  //   return `${a.user.firstName} ${a.user.lastName}`
  // })
  // console.log(commenters, "commenters");
  const [getReply, setGetReply] = React.useState<
    CommentReplyTypes[] | undefined
  >([]);
  const [openReply, setOpenReply] = React.useState(false);
  const [editingCommentIndex, setEditingCommentIndex] = useState<number | null>(
    null
  );

  const { refetch: refetchReply, loading: loadReply } = useQuery(
    GET_COMMENT_REPLY,
    {
      variables: {
        where: {
          comment: {
            id: commentFeed?.id,
          },
        },
      },
      notifyOnNetworkStatusChange: true,
      onCompleted: (data) => {
        // console.log(data.commentReplys, "comment reply");
        if (!loadReply) {
          setEditingCommentIndex(null);
        }
        setGetReply(data.commentReplys);
      },
      onError: (err) => {
        console.log(err);
        const errorMessage = err.graphQLErrors[0]?.extensions?.originalError;
        console.log(errorMessage);
      },
    }
  );
  const textAreaRef = React.useRef<HTMLTextAreaElement | null>(null);

  const replyButtonHandler = (user: string) => {
    const nameToInsert = `${user} `;

    setReplyComment(nameToInsert);

    setTimeout(() => {
      if (textAreaRef.current) {
        const newCursorPosition = nameToInsert.length;
        textAreaRef.current.setSelectionRange(
          newCursorPosition,
          newCursorPosition
        );
        textAreaRef.current.focus();
      }
    }, 0);
  };

  const totalCommentLikes = commentFeed?.commentLikes.length || 0;

  const creator = commentFeed?.creator?.username;
  return (
    <>
      {!hideComment && (
        <div
          className="grid bg-white w-full lg:mt-2 pt-2 px-4 lg:px-4 lg:pb-0"
          key={commentFeed?.id && commentFeed?.createdAt}
        >
          <div className="w-full flex flex-col lg:px-10 lg:py-7 rounded lg:shadow-[1px_-1px_8px_0px_rgba(0,0,0,0.1)] lg:gap-3 gap-1">
            <CommentMenu
              setHideComment={setHideComment}
              hideComment={hideComment}
              handleEdit={handleEdit}
              handleDelete={handleDelete}
              setOpenOption={setOpenOption}
              handleOpenNotice={handleOpenNotice}
              loadFeeds={loadFeeds}
              refetch={refetch}
              openOption={openOption}
              deleteOption={deleteOption}
              commentFeed={commentFeed}
              communityFeed={communityFeed}
              isEdited={isEdited}
              _image={_image}
            />
            <CommentContent
              commentFeed={commentFeed}
              isEdited={isEdited}
              loading={loading}
              handleUpdateComment={handleUpdateComment}
              editedComment={editedComment}
              setEditedComment={setEditedComment}
              openEdit={openEdit}
              handleCloseEdit={handleCloseEdit}
              _image={_image}
            />
            {/* {commentFeed?.id} */}
          </div>
          <div className="flex justify-between text-darkGreen text-[10px] lg:text-base mt-2 font-Rubik font-light">
            <div className="flex font-medium lg:pl-5 relative">
              {createLikeLoading || deleteLikeLoading ? (
                <p>
                  {deleteLikeLoading ? (
                    totalCommentLikes > 1 ? (
                      <span className="absolute left-0 lg:left-3">{`${
                        totalCommentLikes - 1
                      }`}</span>
                    ) : (
                      totalCommentLikes === 1 && " "
                    )
                  ) : (
                    createLikeLoading && (
                      <span className="absolute left-0 lg:left-3">{`${
                        totalCommentLikes + 1
                      }`}</span>
                    )
                  )}
                  <span
                    className={
                      deleteLikeLoading
                        ? "text-darkGreen mr-4 lg:ml-1 ml-2"
                        : "text-red-400 mr-4 lg:ml-1 ml-2"
                    }
                  >
                    Like
                  </span>
                </p>
              ) : (
                <>
                  {commentFeed?.commentLikes &&
                  commentFeed.commentLikes.length > 0 ? (
                    <div className="absolute left-0 lg:left-3">
                      {commentFeed.commentLikes.length}
                    </div>
                  ) : null}
                  <div className="cursor-pointer mr-4 ml-2 lg:ml-1 flex">
                    <button
                      onClick={
                        commentLikeCreator && user.id
                          ? handleDeleteLike
                          : handleCommentLike
                      }
                      className={
                        commentLikeCreator && user.id
                          ? "text-red-400"
                          : "text-darkGreen"
                      }
                    >
                      Like
                    </button>
                  </div>
                </>
              )}
              <button
                onClick={() => {
                  setOpenInput(true);
                  setOpenReply(true);
                  if (creator) {
                    replyButtonHandler(`@${creator}`);
                  }
                }}
              >
                Reply
              </button>
            </div>
          </div>
          {getReply && getReply.length > 0 && !openReply && (
            <div
              className="flex gap-1 text-TransGrey lg:pl-20 text-[9px] lg:text-[12px] mt-2 items-center font-Rubik font-light cursor-pointer"
              onClick={() => setOpenReply(true)}
            >
              <BsArrowReturnRight />

              {`View ${getReply?.length} ${
                getReply.length === 1 ? "reply" : "replies"
              }`}
            </div>
          )}
          {openReply && (
            <CommentReply
              id={commentFeed?.id}
              replyComment={replyComment}
              setReplyComment={setReplyComment}
              openInput={openInput}
              setOpenInput={setOpenInput}
              getReply={getReply}
              refetch={refetchReply}
              loading={loadReply}
              textArea={textAreaRef}
              replyButtonHandler={replyButtonHandler}
              setEditingCommentIndex={setEditingCommentIndex}
              editingCommentIndex={editingCommentIndex}
            />
          )}
        </div>
      )}
    </>
  );
};

export default SingleComent;
